import React from 'react';
import close from "./images/close.png";
import Loading from "./loader";
import AriaModal from "react-aria-modal";
import {enqueueSnackbar} from "notistack";

class LoginCode extends React.Component {
  state = {
    input_hash: '',
    check: false,
    error: null
  };

  handleChange = e => {
    const value = e.target.value.replace(/\D/g, '');
    this.setState({
      input_hash: value,
      error: null
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();

    if (this.state.input_hash.length !== 5) {
      enqueueSnackbar('Код должен содержать 5 цифр', { variant: 'error' });
      return;
    }

    try {
      await this.props.verifyCode(this.state.input_hash);
    } catch (error) {
      enqueueSnackbar('Ошибка проверки кода', { variant: 'error' });
    }
  };

  render() {
    return (
      <AriaModal
        titleId="demo-two-title"
        onExit={this.deactivateModal}
        underlayClickExits={false}
        verticallyCenter={true}
      >
        <form onSubmit={this.handleSubmit}>
          <div id="demo-two-modal" className="modal">
            <img className="close-bttn img" onClick={this.props.onClose} height="35px" width="35px" align="right" src={close} alt="close" style={{ cursor: 'pointer' }}/>
            <header className="modal-header">
              <h2 id="demo-two-title" className="modal-title">
                Введите в поле код из Email
              </h2>
            </header>
            <div className="modal-body-code">
              <div className="centered-input-group">
                <label htmlFor="input_hash" className="radioText">Код из Email</label>
                <input
                    type="text"
                    className="main-input4"
                    name="input_hash"
                    id="input_hash"
                    value={this.state.input_hash}
                    onChange={this.handleChange}
                    maxLength="5"
                    pattern="\d{5}"
                    required
                    inputMode="numeric"
                />
                {this.state.error && <div className="error-message">{this.state.error}</div>}
              </div>
            </div>

            <footer className="modal-footer-code">
              {this.state.check ? (
                  <Loading/>
              ) : (
                  <button type="submit" className="submit-button" disabled={this.state.input_hash.length !== 5}>
                    <b>Отправить</b>
                  </button>
              )}
            </footer>
          </div>
        </form>
      </AriaModal>
    );
  }
}

export default LoginCode;